module.exports = __webpack_public_path__ + "img/declareTitleImg1.87b218db.png";